
import React from 'react';
import {
  CardHeader,
  CardBody,
  Card,
  Col,
  Row,
  Container
} from 'reactstrap';
import '../../assets/css/admin.css';
import AdminNav from './AdminNav';

function AdminHome() {
  // const [dropdownOpen, setDropdownOpen] = useState(false);

  // const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <div className="admin-wrapper">
      <AdminNav />

      <Container fluid className="content">
        <Row>
          <Col md="12">
            <Card className="card-dark">
              <CardHeader className="card-header-dark">Admin Home</CardHeader>
              <CardBody>
                <h3>Welcome to the Admin Dashboard</h3>
                <p>Dashboard stats coming soon, maybe.</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AdminHome;
